import { createContext } from 'react';

export interface LanguageContextType {
  language: string;
  setLanguage: (lang: string) => Promise<void>;
  supportedLanguages: readonly string[];
}

export const LanguageContext = createContext<LanguageContextType | null>(null);
